import { useCallback, useState } from "react";
import ForumPostResponseResource from "common/resources/Project/Config/Forum/ForumPostResponseResource";

export enum EPostCardModal {
	CREATE_POST = "CREATE_POST",
	EDIT_POST = "EDIT_POST",
	DELETE_POST = "DELETE_POST",
}

export const usePostCardModal = () => {
	const [openedModal, setOpenedModal] = useState<EPostCardModal | null>(null);
	const [selectedPost, setSelectedPost] = useState<ForumPostResponseResource | null>(null);

	const isModalOpen = useCallback((modal: EPostCardModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedPost(null);
	}, []);

	const onOpenCreateModal = useCallback(() => {
		setOpenedModal(EPostCardModal.CREATE_POST);
	}, [setOpenedModal]);

	const onOpenEditModal = useCallback(
		(post: ForumPostResponseResource) => {
			setOpenedModal(EPostCardModal.EDIT_POST);
			setSelectedPost(post);
		},
		[setOpenedModal],
	);

	const onOpenDeleteModal = useCallback(
		(post: ForumPostResponseResource) => {
			setOpenedModal(EPostCardModal.DELETE_POST);
			setSelectedPost(post);
		},
		[setOpenedModal],
	);

	return { selectedPost, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenDeleteModal };
};
